import React from "react";
import InvoiceCard from "./InvoiceCard";
import Icon from "../../../components/AppIcon";

const TimelineView = ({
  batchInfo,
  onRetry,
  onViewDetails,
  onCorrectError,
}) => {
  if (!batchInfo) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
          <Icon
            name="FileText"
            size={24}
            color="var(--color-text-secondary)"
            strokeWidth={2}
          />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          No Invoices in Queue
        </h3>
        <p className="text-muted-foreground max-w-md">
          Upload invoices to start the AI-powered validation process. Your
          invoices will appear here for monitoring and management.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {batchInfo.map((batch, index) => (
        <div key={batch.batchId} className="relative">
          {/* Timeline Connector */}
          {index < batch.files.length - 1 && (
            <div className="absolute left-8 top-20 w-0.5 h-8 bg-border z-0" />
          )}

          {batch?.files.map((file) => (
            <InvoiceCard
              invoice={{
                ...file,
                batchName: batch.batchName,
                batchId: batch.batchId,
              }}
              viewMode="timeline"
              onRetry={onRetry}
              onViewDetails={onViewDetails}
              onCorrectError={onCorrectError}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TimelineView;
